import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '#environments';
import { TelemetryService, ToasterService } from '#services';

/**
 * Centralized error handling so failures surface consistently instead of being
 * swallowed:
 *  - network-level failures (status 0 / server down) route to the /500 page;
 *  - other errors show a toast.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private _toaster = inject(ToasterService);
  private _router = inject(Router);
  private _telemetryService = inject(TelemetryService);

  handleError(error: unknown): void {
    this._telemetryService.trackException({ exception: error instanceof Error ? error : new Error(String(error)) });

    if (environment.envName === 'local') {
      console.error(error);
    }

    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) {
        this._router.navigate(['/500']);
        return;
      }

      if (error.status === 403) {
        this._toaster.showError('You are not allowed to perform this action.');
        return;
      }
    }

    this._toaster.showError('Something went wrong. Please try again.');
  }
}
